import { axiosClient } from './AxiosClient'
import { baseURL } from './Config'
import dayjs from 'dayjs'

function listActivityLog(startDate, endDate, type, callback, errorCallback){
    let url = "/log/activity-log"

    var queryLog = {}
    if(startDate !== null){
        queryLog["start_date"] = dayjs(startDate).format("MM/DD/YYYY HH:mm")
    }
    if(endDate !== null){
        queryLog["end_date"] = dayjs(endDate).format("MM/DD/YYYY HH:mm")
    }
    if(type !== ""){
        queryLog["type"] = type
    }

    axiosClient.get(url, {
        params: queryLog
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteLog(acitivityId, callback, errorCallback){
    let url = "/log/activity-log/delete"

    var bodyForm = new FormData()
    bodyForm.append("activity_id", acitivityId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listUserlog(startDate, endDate, companyId, isExport, callback, errorCallback){
    let url = "/report/userLog"

    var queryLog = {}
    if(startDate !== null){
        queryLog["start"] = dayjs(startDate).format("MM/DD/YYYY HH:mm")
    }
    if(endDate !== null){
        queryLog["end"] = dayjs(endDate).format("MM/DD/YYYY HH:mm")
    }
    if(companyId !== ""){
        queryLog["companyId"] = companyId
    }
    if(isExport){
        queryLog["isExport"] = isExport
    }

    axiosClient.get(url, {
        params: queryLog
    })
    .then((response)=>{
        let data = response.data
        let content = data.content
        let count = data.count
        if(!isExport){
            callback(content, count)
        }else{
            window.open(baseURL + "/" + data.path, "_self")
            callback()
        }
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listNewsLog(startDate, endDate, companyId, title, type, isExport, callback, errorCallback){
    let url = "/report/newsLog"

    var queryLog = {}
    if(startDate !== null){
        queryLog["start"] = dayjs(startDate).format("MM/DD/YYYY HH:mm")
    }
    if(endDate !== null){
        queryLog["end"] = dayjs(endDate).format("MM/DD/YYYY HH:mm")
    }
    if(companyId !== ""){
        queryLog["companyId"] = companyId
    }
    if(title !== ""){
        queryLog["title"] = title
    }
    if(isExport){
        queryLog["isExport"] = isExport
    }
    queryLog["type"] = type

    axiosClient.get(url,{
        params: queryLog
    })
    .then((response)=>{
        let data = response.data
        let content = data.content
        if(!isExport){
            callback(content)
        }else{
            window.open(baseURL + "/" + data.path, "_self")
            callback()
        }
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
}

export { listActivityLog, deleteLog, listUserlog, listNewsLog }